<template>
  <div class="">
    <v-list dense class="text-left">
      <v-list-item>
        <v-list-item-content class="text-left">Evaluation criteria</v-list-item-content>
      </v-list-item>
      <v-divider/>

      <v-list-group v-for="(item, idx) in criteria"  :key="idx">
        <template v-slot:activator>
          <v-text-field v-model="item.name" hide-details rounded>
            <template v-slot:prepend>
              <v-icon>mdi-bookmark-multiple</v-icon>
            </template>
          </v-text-field>
        </template>

        <v-list-item v-for="(children, i) in item.children" :key="i" class="mx-4">
          <v-text-field v-model="children.name" hide-details rounded>
            <template v-slot:prepend>
              <v-icon>mdi-radiobox-marked</v-icon>
            </template>
            <template v-slot:append>
              <v-btn small icon @click="item.children.splice(i, 1)"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
          </v-text-field>
        </v-list-item>
        <v-divider/>
        <v-list-item @click="item.children.push({name: ''})" class="mx-4">
          <v-list-item-content>Add sub criteria</v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider/>
        <v-list-item @click="criteria.splice(idx, 1)" class="mx-4" color="red">
          <v-list-item-content>Remove criteria</v-list-item-content>
          <v-list-item-icon>
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>

      <v-list-item v-if="criteria.length === 0">
        <v-list-item-subtitle class="text-left">No data available</v-list-item-subtitle>
      </v-list-item>

      <v-divider/>
      <v-btn  block color="primary" @click="criteria.push({name: '', children: []})">
        Create new criteria
      </v-btn>
    </v-list>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      default: Array
    },
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    criteria: [],
    new_item: ''
  }),
  watch: {
    criteria: function (val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    this.criteria = this.value ?? []
  },
}
</script>